module.exports = __webpack_public_path__ + "img/34.63be051f.png";